import { GatewayService } from '../GatewayService';
import { PhicubeResponse } from '../interface/PhicubeResponse';

export class EsqueciMinhaSenhaModel {
    email: String

    enviaEsqueciMinhaSenha(data: EsqueciMinhaSenhaModel): Promise<PhicubeResponse> {
        return new GatewayService().requestGet('/api/user/esqueciSenha/' + data.email, true)
    }
}